import { render, staticRenderFns } from "./ResumeCard.vue?vue&type=template&id=45f396d4&scoped=true&"
import script from "./ResumeCard.vue?vue&type=script&lang=ts&"
export * from "./ResumeCard.vue?vue&type=script&lang=ts&"
import style0 from "./ResumeCard.vue?vue&type=style&index=0&id=45f396d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f396d4",
  null
  
)

export default component.exports